import React, { useContext } from 'react';

import FileRow from 'components/file-row';
import Button from 'components/button';

import LocaleContext from 'contexts/locale-context';

import formatSize from 'helpers/format-size';

import './index.css';

const sumSizes = (files = []) => {
  let sum = 0;

  files.forEach(file => sum += file.file.size);

  return sum;
}

const FilesList = ({ files = [], onClearFiles, onRemoveFile }) => {
  const { translations } = useContext(LocaleContext);
  const componentTranslations= translations['files-list'];
  const filesCount = files.length;

  return (
    <div className='files-list-container'>
      <div className='files-row__container'>
        {
          files.map((file, i) => 
          <FileRow key={i} file={file} onRemoveFile={onRemoveFile} />)
        }
      </div>
      <div className='files-list__footer'>
      <p><b>{filesCount === 1 ? `${filesCount} file` : `${filesCount} files`}{' '}•{' '}{formatSize(sumSizes(files))}</b></p>
        <Button btnType='none' onClick={onClearFiles}>
          {componentTranslations.clear_all}
        </Button>
      </div>
    </div>
  );
};

export default FilesList;